<div class="container">
    <div [id]="chartId" class="chart-wrapper"></div>
</div>
